var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay-code-panel"},[_c('span',[_vm._v("请用"+_vm._s(_vm.payName)+"扫码支付，支付金额 "+_vm._s(_vm.payPrice))]),_c('div',{ref:"qrCodeUrl",staticClass:"qr-code"})])
}
var staticRenderFns = []

export { render, staticRenderFns }